import { render } from "./GroupChat.vue?vue&type=template&id=f6d3ffd8&scoped=true&ts=true"
import script from "./GroupChat.vue?vue&type=script&lang=ts"
export * from "./GroupChat.vue?vue&type=script&lang=ts"

import "./GroupChat.vue?vue&type=style&index=0&id=f6d3ffd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d3ffd8"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QBadge,QBtn,QInput});
